import Page from "@/layout/Page";
import React, {useEffect, useState} from "react";
import {parseString} from "xml2js";
import Input from "@/components/Input/Input";
import {Card, TabBox, Tabs} from "@varymadellc/my-weed-club-component-library";
import AudioPlayer from "@/components/AudioPlayer/AudioPlayer";
import MediaCenterBox from "@/components/ImageCenter/MediaCenterBox";
import {useRouter} from "next/navigation";
import YoutubePlayer from "@/components/YoutubePlayer/YoutubePlayer";

const getShowsFromShowData = (showData) => {
    return showData.map((show) => {
        switch (show?.title) {
            case 'The Hippy Chronicles':
                const hippyChroniclesData = show.data?.rss?.channel?.[0];

                return {
                    title: hippyChroniclesData?.title?.[0],
                    image: hippyChroniclesData?.["itunes:image"]?.[0]?.$?.href || '',
                    lastBuildDate: hippyChroniclesData?.lastBuildDate,
                    description: hippyChroniclesData?.description?.[0],
                    thumb: hippyChroniclesData?.image?.[0]?.url[0],
                    tags: hippyChroniclesData.tags,
                    advertisement: show.advertisement,
                    advertisementLink: show.advertisementLink,
                    episodes: [...hippyChroniclesData?.item?.slice(0, 10).map((episode) => {
                        return {
                            title: episode.title?.[0],
                            description: episode.description?.[0],
                            audioSrc: episode.enclosure?.[0]?.$?.url,
                            thumb: episode?.image?.[0]?.url?.[0],
                            pubDate: episode.pubDate,
                            tags: episode.tags
                        };
                    })]
                };
            case 'The Hippy Chronicles (youtube)':
                const hippyChroniclesYoutubeData = show.data?.feed?.entry;

                return {
                    title: show.title,
                    image: hippyChroniclesYoutubeData?.[0]?.["media:group"]?.[0]?.["media:thumbnail"]?.[0]?.$?.url || '',
                    lastBuildDate: hippyChroniclesYoutubeData?.[0]?.published,
                    description: hippyChroniclesYoutubeData?.[0]?.summary,
                    thumb: hippyChroniclesYoutubeData?.[0]?.["media:group"]?.[0]?.["media:thumbnail"]?.[0]?.$?.url,
                    tags: hippyChroniclesYoutubeData?.[0]?.category?.map((category) => category?.$?.term),
                    advertisement: show.advertisement,
                    advertisementLink: show.advertisementLink,
                    episodes: [...hippyChroniclesYoutubeData?.slice(0, 10).map((episode) => {
                        return {
                            title: episode.title?.[0],
                            description: episode.summary?.[0],
                            videoId: episode.id[0].split(':')[2],
                            thumb: episode?.["media:group"]?.[0]?.["media:thumbnail"]?.[0]?.$?.url,
                            pubDate: episode.published,
                            tags: episode.category?.map((category) => category?.$?.term)
                        };
                    })]
                };
            default:
                return {};
        }
    });
}

export default function MediaIndex({showData, error}) {
    const navigate = useRouter();

    const [item, setItem] = useState<any>(null);

    useEffect(() => {
        const headerScript = document.createElement('script');
        headerScript.src = 'https://embed.radio.co/js/embed.min.2023.12.07.1617.js';
        headerScript.async = true;
        document.body.appendChild(headerScript);
    }, []);

    const [searchTerm, setSearchTerm] = React.useState('');

    const podcasts = getShowsFromShowData(showData);

    useEffect(() => {
        // setItem(podcasts[0]);
    }, []);

    const filterResults = (results) => {
        return results.filter((item) => {
            const foundByTitle = item.title.toLowerCase().includes(searchTerm.toLowerCase());

            const foundByDescription = item?.description?.toLowerCase()?.includes(searchTerm?.toLowerCase());

            const foundByTags = item.tags?.some((tag) => {
                return tag.toLowerCase().includes(searchTerm.toLowerCase());
            });

            return foundByTitle || foundByDescription || foundByTags;
        });
    };

    return <Page title="Media">
        <div className="flex flex-col gap-4">
            <div className="flex-[3]">
                <h3>Podcasts</h3>
                {
                    item &&
                    <Card key={item.id} className="w-full" id="player">
                        {
                            item?.audioSrc
                                ? <AudioPlayer className="w-full" src={item.audioSrc}/>
                                : <YoutubePlayer videoId={item.videoId}/>
                        }
                        <hr className="my-2"/>
                        {
                            item?.pubDate && <div className="flex flex-col justify-between">
                                <h4 className="rounded-lg bg-primary text-black text-xs p-1 text-center m-1">{item.pubDate}</h4>
                            </div>
                        }
                        <h3 className="">{item.title}</h3>
                        {item.image &&
                            <MediaCenterBox className="w-full">
                                <img src={item.image} alt={item.title}/>
                            </MediaCenterBox>
                        }
                        <div dangerouslySetInnerHTML={{__html: item.description}}/>
                        <div className="flex flex-col justify-between">
                            {
                                item.tags?.map((tag) => {
                                    return <h4 key={tag}
                                               className="rounded-lg bg-primary text-black text-xs p-1 text-center m-1">{tag}</h4>
                                })
                            }
                        </div>
                    </Card>
                }
            </div>
            <div className="flex flex-1 flex-col gap-4">
                <Input onChange={(event) => {
                    setSearchTerm(event.target.value || '');
                }} type="text" placeholder="Search"/>
                <TabBox tabs={podcasts.map((podcast) => podcast.title)}>
                    {
                        podcasts.map((podcast) => {
                            if (Object.keys(podcast).length < 3) {
                                return null;
                            }

                            const {
                                id,
                                title,
                                lastBuildDate,
                                episodes,
                                advertisement,
                                advertisementLink
                            } = podcast || {};

                            return <div key={id}>
                                <div className="flex flex-col justify-between">
                                    <h3 className="break-words">{title}</h3>
                                    {advertisement &&
                                        <MediaCenterBox className="w-full">
                                            {
                                                advertisementLink ?
                                                    <a href={advertisementLink} target="_blank" rel="noreferrer">
                                                        <img src={advertisement} alt={title}/>
                                                    </a> :
                                                    <img src={advertisement} alt={title}/>
                                            }
                                        </MediaCenterBox>
                                    }
                                    <h4 className="rounded-lg bg-primary text-black text-xs p-1 text-center m-1">Last
                                        updated: {lastBuildDate}</h4>
                                    {
                                        episodes && episodes.map((episode) => {
                                            return <Card
                                                onClick={() => {
                                                    setItem(episode);

                                                    navigate.push(`/media#player`);
                                                }}
                                                key={episode.title} className="my-2">
                                                <div className="flex flex-row mb-2">
                                                    {episode.thumb &&
                                                        <img className="max-h-[100px] mr-2 rounded" src={episode?.thumb}
                                                             alt={episode.title}/>}
                                                    <h4 className="bg-dark-black p-2 rounded w-full">{episode.title}</h4>
                                                </div>
                                                {episode?.description && <p dangerouslySetInnerHTML={{__html: String(episode.description).substring(0, 200)}}/>}
                                            </Card>
                                        })
                                    }
                                </div>
                            </div>
                        })
                    }
                </TabBox>
            </div>
        </div>
    </Page>
}

export async function getStaticProps() {
    const shows = [
        {
            title: 'The Hippy Chronicles',
            rss: 'https://anchor.fm/s/a203384/podcast/rss',
            advertisement: '/ads/hippylifeent.png',
            advertisementLink: 'https://www.youtube.com/@TheHippyChronicles',
            data: [] // get populated in getStaticProps,
        },
        {
            title: 'The Hippy Chronicles (youtube)',
            rss: 'https://www.youtube.com/feeds/videos.xml?channel_id=UCI6Wik4pyoVpl0XUMXZgyHA',
            advertisement: '/ads/hippylifeent-youtube.png',
            advertisementLink: 'https://www.youtube.com/@TheHippyChronicles',
            data: [] // get populated in getStaticProps,
        },
    ]

    try {
        const populatedShows = await Promise.all(await populateShowsPromises(shows));

        return {
            props: {
                showData: populatedShows
            }
        };
    } catch (error: any) {
        return {
            props: {
                error: error.message
            }
        };
    }
}

async function populateShowsPromises(shows) {
    return [...shows].map(async (show) => {
        if (show?.rss) {
            const res = await fetch(show.rss);

            const xml = await res.text();

            show.data = await new Promise((resolve, reject) => {
                parseString(xml, (err, result) => {
                    if (err) reject(err);
                    else resolve(result);
                });
            });
        }

        return show;
    });
}